export default class RolesEnum {
    static admin = "admin";
    static librarian = "librarian";
    static user = "user";
}